<div class="content-product-card">
    <div class="product-card is-loaded" [class.is-loading]="!imageLoaded" [class.is-loaded]="imageLoaded" [class.is-loaded-video]="videoLoaded">
        <media-skeleton [ratio]="config().media.ratio" [skeletonTextPosition]="config().textPosition"></media-skeleton>

        <figure class="product-card-figure">
            <ng-content *ngTemplateOutlet="config().clickable ? anchorTemplate : noAnchorTemplate"></ng-content>
        </figure>
    </div>
</div>
<!-- Template para productos sin enlace -->
<ng-template #noAnchorTemplate>
    <ng-content *ngTemplateOutlet="productCardImage"></ng-content>
</ng-template>

<!-- Template para productos clickables, se pintara en el DOM un enlace -->
<ng-template #anchorTemplate>
    <a href="{{ linkHref() }}" style="cursor: default" (click)="preventNavigation($event)">
        <ng-content *ngTemplateOutlet="productCardImage"></ng-content>
    </a>
</ng-template>

<!-- Template para productos sin enlace, no pintamos div con evento de click -->
<ng-template #noClickableTemplate>
    <ng-content *ngTemplateOutlet="mediaTemplate"></ng-content>
</ng-template>

<!-- Template para productos clickables, se pintara en el DOM un div con el evento click -->
<ng-template #clickableTemplate>
    <div
        class="h-100 cursor-pointer"
        productClick
        [bannerLinks]="bannerLinks()"
        (clickProduct)="onClickMedia($event)"
        (keydown)="handleKeyDown($event)"
    >
        <ng-content *ngTemplateOutlet="mediaTemplate"></ng-content>
    </div>
</ng-template>

<ng-template #productCardImage>
    <div class="product-card-img ar-{{ config().media.ratio }}" [class.image-carousel-loaded]="imageCarouselLoaded">
        @if (imageUrl()) {
            <ng-content *ngTemplateOutlet="config().clickable && !showMediaCarousel() ? clickableTemplate : noClickableTemplate"></ng-content>
        }
        <ng-content select="[productCardBadge]" class="product-card-badge"></ng-content>
    </div>

    <ng-content select="[productCardFooter]" class="product-card-info"></ng-content>
</ng-template>

<ng-template #mediaTemplate>
    @defer (when videoUrl() && showVideo) {
        <media-video
            class="anim-2"
            [mediaControls]="true"
            [videoUrl]="videoUrl()"
            [hasInView]="hasInView()"
            (eventLoaded)="onVideoLoad()"
        ></media-video>
    }

    @if (showMediaCarousel()) {
        @if (isMobile() || animationCarousel) {
            @defer (on viewport) {
                <ng-content *ngTemplateOutlet="mediaCarousel"></ng-content>
            } @placeholder {
                <div class="w-100 h-100" style="position: absolute; z-index: 1"></div>
            }
        } @else {
            @defer (on hover) {
                <ng-content *ngTemplateOutlet="mediaCarousel"></ng-content>
            } @placeholder {
                <div class="w-100 h-100" style="position: absolute; z-index: 1"></div>
            }
        }
    }

    @if (!showMediaCarousel() || !imageCarouselLoaded) {
        <div
            class="anim"
            media-image
            [imageUrl]="imageUrl()"
            [imageModel]="config().media"
            (imageLoaded)="onImageLoad($event)"
            (imageError)="onImageError($event)"
        ></div>
    }
</ng-template>

<ng-template #mediaCarousel>
    <media-carousel
        class="anim-2"
        [loadAllImages]="isMobile()"
        [productImages]="productImages()"
        [imageModel]="config().media"
        [animationCarousel]="animationCarousel"
        (imageLoaded)="onImageCarouselLoad($event)"
        (imageError)="onImageError($event)"
        (clickMedia)="onClickMedia($event)"
    ></media-carousel>
</ng-template>
